import { ComponentPropsWithoutRef } from 'react';
import { DialogContent } from '@sib/ui';

export enum DetailsModalView {
  Details = 'details',
  Form = 'form',
}

const NESTED_OVERLAY_SELECTOR =
  '[data-radix-popper-content-wrapper], [data-radix-select-content], [cmdk-root]';

type DialogContentProps = ComponentPropsWithoutRef<typeof DialogContent>;

export const isNestedOverlayInteraction = (target: EventTarget | null) =>
  target instanceof Element && Boolean(target.closest(NESTED_OVERLAY_SELECTOR));

const preventCloseOnNestedOverlay = (event: {
  defaultPrevented: boolean;
  preventDefault: () => void;
  target: EventTarget | null;
}) => {
  if (!event.defaultPrevented && isNestedOverlayInteraction(event.target))
    event.preventDefault();
};

export const withPointerDownOutsideGuard =
  (
    handler?: DialogContentProps['onPointerDownOutside']
  ): NonNullable<DialogContentProps['onPointerDownOutside']> =>
  event => {
    handler?.(event);
    preventCloseOnNestedOverlay(event);
  };

export const withInteractOutsideGuard =
  (
    handler?: DialogContentProps['onInteractOutside']
  ): NonNullable<DialogContentProps['onInteractOutside']> =>
  event => {
    handler?.(event);
    preventCloseOnNestedOverlay(event);
  };
